import { CHATBOT_ID } from '../constants/chatbotId';
import { IChatbotMessageSchema } from '../types/chatbot';
import { TMessageSchema } from '../types/messages';

export const mapChatbotMessageToChatMessage = (
  message: IChatbotMessageSchema,
  index?: number,
  unreadMessagesCount?: number,
): TMessageSchema => {
  const { offers, communicationId, htmlText, text } = message;

  return {
    ...message,
    chatId: CHATBOT_ID,
    offers:
      offers?.map(offer => ({
        ...offer,
        url: `/sale/flat/${offer.realtyOfferId}/`,
      })) || [],
    userId: 0,
    rowVersionV2: '',
    communicationId: communicationId ?? undefined,
    htmlText: htmlText ?? undefined,
    text: text ?? undefined,
    unread: index !== undefined && !!unreadMessagesCount && index < unreadMessagesCount,
  };
};
